import { isCapacitorNative } from '@utils/capacitor-utils';
import { getBreakpointSizes } from 'ids-wc';
import { useState, useEffect } from 'react';

const dsBreakpoints = getBreakpointSizes();
// { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536, xxl: 1920 }

const MOBILE_SIZE_THRESHOLD = dsBreakpoints.md || 900;
const useMobileDetector = () => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  const handleResize = () => {
    setIsMobile(window.innerWidth <= MOBILE_SIZE_THRESHOLD);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isMobile || isCapacitorNative();
};

export default useMobileDetector;
